import { GastroProductKind, ProductsAppDataGastroProduct } from '@models/products'
import { useProductsAppData } from '@modules/products/hooks/use-products-app-data'

export const useGastroProductProvider = (kind: GastroProductKind): ProductsAppDataGastroProduct => {
  const productAppData = useProductsAppData()

  return productAppData.gastro_products[kind]
}
